import { __decorate, __metadata } from "tslib";
import { RuleContext, AsyncStage } from '../RuleContext';
import { Observable, Computed } from '../../Model/Decorators';
import { NeoTypeInfo } from '../../Model/NeoTypeInfo';
var RuleValidator = /** @class */ (function () {
    function RuleValidator(propertyInstance, rule) {
        this.propertyInstance = propertyInstance;
        this.rule = rule;
        // Last context which called beginAsync
        this.asyncContext = null;
        this.asyncStage = AsyncStage.None;
        // Properties this rule has been added to, including the primary property.
        this.properties = [];
        this.refreshValue = 0;
        NeoTypeInfo.makeObservable(this);
    }
    Object.defineProperty(RuleValidator.prototype, "ruleId", {
        get: function () {
            return this.rule.ruleId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RuleValidator.prototype, "ruleContext", {
        get: function () {
            void this.refreshValue; // create dependency on refreshValue
            var ruleContext = new RuleContext(this);
            if (this.asyncStage !== AsyncStage.Completing) {
                this.asyncContext = null;
            }
            this.rule.checkRule(this.propertyInstance, ruleContext);
            if (this.asyncContext) {
                ruleContext.merge(this.asyncContext, true);
            }
            return ruleContext;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], RuleValidator.prototype, "refreshValue", void 0);
    __decorate([
        Computed(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], RuleValidator.prototype, "ruleContext", null);
    return RuleValidator;
}());
export default RuleValidator;
